const iconNames: Readonly<{
    [key: string]: string,
}> = {
    add: 'ion-plus',
    substract: 'ion-ios-minus-empty',
    applyAll: 'ion-ios-world',
    applyAllBelow: 'ion-android-arrow-dropdown-circle',
    apps: 'ion-android-apps',
    check: 'ion-checkmark',
    checkbox: 'ion-android-checkbox',
    checkboxOutlineBlank: 'ion-android-checkbox-outline-blank',
    checkCircle: 'ion-checkmark-circled',
    chevronDown: 'ion-chevron-down',
    chevronLeft: 'ion-chevron-left',
    chevronRight: 'ion-chevron-right',
    chevronUp: 'ion-chevron-up',
    clipboard: 'ion-clipboard',
    close: 'ion-close',
    code: 'ion-code',
    codeWorking: 'ion-code-working',
    download: 'fa fa-download',
    delete: 'ion-android-delete',
    refresh: 'ion-android-refresh',
    calendar: 'ion-ios-calendar-outline',

    documentText: 'fa fa-file-o',

    json: 'fa fa-file-code-o',
    xml: 'fa fa-file-code-o',
    csv: 'fa fa-file-code-o',

    docx: 'fa fa-file-word-o',
    rtf: 'fa fa-file-word-o',
    otf: 'fa fa-file-word-o',
    msword: 'fa fa-file-word-o',

    pdf: 'fa fa-file-pdf-o',

    pptx: 'fa fa-file-powerpoint-o',
    ppt: 'fa fa-file-powerpoint-o',

    xls: 'fa fa-file-excel-o',
    xlxs: 'fa fa-file-excel-o',

    png: 'fa fa-file-image-o',
    jpg: 'fa fa-file-image-o',
    jpeg: 'fa fa-file-image-o',
    fig: 'fa fa-file-image-o',

    undo: 'fa fa-undo',
    uploadFa: 'fa fa-upload',

    dropbox: 'ion-social-dropbox',
    edit: 'ion-edit',
    error: 'ion-android-alert',
    forward: 'ion-forward',
    copy: 'ion-ios-copy',
    globe: 'ion-android-globe',
    world: 'ion-ios-world',
    map: 'ion-android-map',
    googleDrive: 'ion-social-googleplus-outline',
    hamburger: 'ion-android-menu',
    help: 'ion-help-circled',
    info: 'ion-ios-information',
    link: 'ion-link',
    list: 'ion-ios-list-outline',
    loading: 'ion-load-c',
    locked: 'ion-locked',
    logout: 'ion-log-out',
    openLink: 'ion-android-open',
    overflowHorizontal: 'ion-android-more-horizontal',
    person: 'ion-android-person',
    remove: 'ion-android-remove',
    removeCircle: 'ion-android-remove-circle',
    search: 'ion-search',
    text: 'ion-document',
    thumbsUp: 'ion-thumbsup',
    thumbsDown: 'ion-thumbsdown',
    upload: 'ion-android-upload',
    user: 'ion-android-contact',
    warning: 'ion-alert-circled',
    wrench: 'ion-wrench',
    checkAll: 'ion-android-done-all',
    save: 'fa fa-save',

    next: 'ion-chevron-right',
    prev: 'ion-chevron-left',
    circle: 'ion-record',

    chart: 'fa fa-sitemap',
    eye: 'ion-eye',
    camera: 'ion-camera',
    textFormat: 'ion-ios-circle-filled',
    chrome: 'ion-social-chrome',
};

export default iconNames;



// WEBPACK FOOTER //
// ./src/constants/iconNames.ts